/* Vortex theme — SHELL chrome only (mobile menu + appearance toggle). Native navigation.
   Everything a storefront shares (search, cart, wishlist, quick view, personalisation, PDP
   variants, collection faceting) lives in the framework's <vortex-storefront backend="shopify">
   element, wired in layout/theme.liquid — the theme no longer re-implements any of it. */

/* ── Shell: mobile menu ─────────────────────────────────────────────────── */
(function () {
  // Mobile nav menu (hamburger). Closing runs through one function on purpose: the outside-click
  // path used to drop `data-menu` on its own and leave aria-expanded="true" behind, so a screen
  // reader kept announcing an open menu that was not on screen.
  var closeMenu = function (hd, refocus) {
    if (!hd) { return; }
    hd.setAttribute('data-menu', 'closed');
    var t = hd.querySelector('[data-menu-toggle]');
    if (t) {
      t.setAttribute('aria-expanded', 'false');
      if (refocus) { t.focus(); }
    }
  };

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (t) {
      var hd = t.closest('.vxt-hd');
      var open = hd.getAttribute('data-menu') === 'open';
      if (open) { closeMenu(hd); } else {
        hd.setAttribute('data-menu', 'open');
        t.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (!e.target.closest('.vxt-hd')) { closeMenu(document.querySelector('.vxt-hd[data-menu="open"]')); }
  });

  // Escape closes it and hands focus back to the burger — the menu is a disclosure the keyboard
  // could open but not leave.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') { return; }
    var openHd = document.querySelector('.vxt-hd[data-menu="open"]');
    if (openHd) { closeMenu(openHd, true); }
  });
})();

/* ── Appearance toggle (dark ⇄ light) ───────────────────────────────────── */
(function () {
  // VortexAppearance owns the state, the storage key and the anti-flash swap; this only drives
  // it and mirrors the button's label/icon. Two mounts (header button ≥900px, labelled menu row
  // below) drive one state, so this reads them as a set rather than by id.
  var appBtns = document.querySelectorAll('[data-vxt-appearance]');
  if (!appBtns.length) { return; }
  var syncAppBtn = function () {
    var res = (window.VortexAppearance && window.VortexAppearance.resolved()) || 'dark';
    var toLight = res === 'dark';
    var label = toLight ? 'Switch to light theme' : 'Switch to dark theme';
    [].forEach.call(appBtns, function (b) {
      // The two mounts answer different questions: the header icon offers an ACTION ("switch to
      // light"), the menu row reports a STATE ("Dark theme: on"). Same toggle, opposite phrasing
      // — so aria follows the mount's own role rather than one blanket attribute.
      if (b.getAttribute('role') === 'switch') {
        b.setAttribute('aria-checked', toLight ? 'true' : 'false');
      } else {
        b.setAttribute('aria-pressed', toLight ? 'false' : 'true');
        if (b.hasAttribute('title')) { b.setAttribute('title', label); }
        if (b.hasAttribute('aria-label')) { b.setAttribute('aria-label', label); }
      }
      var sw = b.querySelector('[data-vxt-appearance-switch]');
      if (sw) { sw.classList.toggle('on', toLight); }
    });
  };
  [].forEach.call(appBtns, function (b) {
    b.addEventListener('click', function () {
      if (window.VortexAppearance) { window.VortexAppearance.toggle(); }
    });
  });
  document.addEventListener('vortex-appearance-change', syncAppBtn);
  syncAppBtn();
})();
